import classNames from 'classnames';
import React, { useEffect } from 'react';
import { isSafari, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

interface VideoWithLoopProps {
  video1Webm?: any;
  video1Mp4?: any;
  video2Webm?: any;
  video2Mp4?: any;
}

export const VideoWithLoop = ({
  video1Mp4,
  video2Mp4,
  video1Webm,
  video2Webm,
}: VideoWithLoopProps) => {
  const __ = useTranslation().t;
  useEffect(() => {
    const startVideo = document.getElementById('oejr-video-1');
    const loopVideo: any = document.getElementById('oejr-video-2');

    startVideo?.addEventListener('ended', function () {
      loopVideo?.play();
      document.getElementById('oejr-video-1')?.classList.add('hidden-video');
      document.getElementById('oejr-video-2')?.classList.remove('hidden-video');
    });
  }, []);

  return (
    <div
      id="looped-video-wrapper"
      className={classNames(isSafari && 'is-safari', isMobile && 'is-mobile')}
    >
      <video
        autoPlay
        muted
        playsInline
        disableRemotePlayback
        disablePictureInPicture
        id="oejr-video-1"
      >
        {!!video1Webm && <source src={video1Webm} type="video/webm" />}
        {!!video1Mp4 && <source src={video1Mp4} type="video/mp4" />}
        {__('browserNoVideoSupport')}
      </video>
      <video
        muted
        loop
        autoPlay
        playsInline
        disableRemotePlayback
        disablePictureInPicture
        id="oejr-video-2"
        className="hidden-video"
      >
        {!!video2Webm && <source src={video2Webm} type="video/webm" />}
        {!!video2Mp4 && <source src={video2Mp4} type="video/mp4" />}
        {__('browserNoVideoSupport')}
      </video>
      <div className="video-border" />
    </div>
  );
};
